module.exports = __webpack_public_path__ + "img/failed_icon.51b45977.png";